import { useState, useEffect } from 'react'

interface LocationState {
  location: string
  loading: boolean
  error: boolean
}

export function useLocation() {
  const [state, setState] = useState<LocationState>({
    location: '',
    loading: true,
    error: false
  })

  useEffect(() => {
    if (!navigator.geolocation) {
      setState({ location: '', loading: false, error: true })
      return
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
            {
              headers: {
                'User-Agent': 'MoriApp/1.0 (meetmori.app)'
              }
            }
          )
          const data = await response.json()

          const city = data.address?.city
            ?? data.address?.town
            ?? data.address?.village
            ?? data.address?.municipality
            ?? ''
          const country = data.address?.country ?? ''

          const locationString = city && country
            ? `${city}, ${country}`
            : city || country || ''

          setState({
            location: locationString,
            loading: false,
            error: false
          })
        } catch {
          setState({ location: '', loading: false, error: true })
        }
      },
      () => {
        // Permission denied or error — silent fail
        setState({ location: '', loading: false, error: true })
      },
      { timeout: 5000, maximumAge: 60000 }
    )
  }, [])

  return state
}
